import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

export interface CloverDevice {
  id: string;
  name: string | null;
  model: string | null;
  serial: string | null;
}

/**
 * Device picker for the "Reprint receipt" flow.
 *
 * Shown only when the default merchant-wide print path failed (e.g. no
 * device available to Clover's auto-routing) and we want the cashier to
 * pick a specific Mini/Flex/Station to target. The dialog is a thin
 * presentational wrapper — the parent component is responsible for
 * fetching the devices, reacting to the selection, and re-firing the
 * reprint with the picked deviceId.
 */
@Component({
  selector: 'app-device-picker-dialog',
  templateUrl: './device-picker-dialog.component.html',
  styleUrls: ['./device-picker-dialog.component.scss']
})
export class DevicePickerDialogComponent {
  devices: CloverDevice[];
  title: string;
  emptyMessage: string;

  constructor(
    private dialogRef: MatDialogRef<DevicePickerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: { devices: CloverDevice[]; title?: string; emptyMessage?: string }
  ) {
    this.devices = data?.devices || [];
    this.title = data?.title || 'Select a device';
    this.emptyMessage = data?.emptyMessage || 'No connected devices found.';
  }

  pick(d: CloverDevice) {
    this.dialogRef.close({deviceId: d.id, device: d});
  }

  cancel() {
    this.dialogRef.close(null);
  }

  describe(d: CloverDevice): string {
    const parts: string[] = [];
    if (d.model) parts.push(d.model);
    if (d.serial) parts.push('SN: ' + d.serial);
    return parts.join(' • ');
  }
}
